





















import {
  computed,
  defineComponent,
  ref,
  useRoute,
  useRouter,
  watch
} from '@nuxtjs/composition-api'
import MobileSideBarHeader from '~/components/car/classifieds/search/mobile/MobileSideBarHeader.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { useI18n } from '~/compositions/i18n'
import { ciXml } from '~/icons/source/regular/xml'
import { ciParts } from '~/icons/source/regular/parts'
import { ciVehicles } from '~/icons/source/brand/vehicles'
import SideHeader from '~/components/shared/side-header/SideHeader.vue'
import { ciVerified } from '~/icons/source/regular/verified'
import AppSnackbar from '~/components/car/AppSnackbar.vue'

export default defineComponent({
  name: 'xml-layout',
  components: {
    AppSnackbar,
    SideHeader,
    MobileSideBarHeader
  },
  setup() {
    const { t } = useI18n()
    const showMobileFacets = ref(false)
    const router = useRouter()
    const route = useRoute()
    const currentRouteIndex = ref(0)
    const menu = [
      {
        label: t('xml_specifications'),
        icon: ciXml,
        routeName: '__specifications'
      },
      {
        label: t('parts_and_small_classifieds'),
        icon: ciParts,
        routeName: '__xyma_parts_xml_docs'
      },
      {
        label: t('vehicles'),
        icon: ciVehicles,
        routeName: '__vehicles_xml_docs'
      },
      {
        label: t('validator'),
        icon: ciVerified,
        routeName: '__validator_xml_docs'
      }
    ]
    function toggleSidebar() {
      isSidebarVisible.value = !isSidebarVisible.value
    }

    watch(
      route,
      () => {
        currentRouteIndex.value = menu.findIndex(
          m => m.routeName === router.currentRoute.name
        )
      },
      { immediate: true }
    )

    const nextUrl = computed(() => {
      if (currentRouteIndex.value + 1 < menu.length) {
        return router.resolve({
          name: menu[currentRouteIndex.value + 1].routeName
        }).href
      }
      return null
    })
    const previousUrl = computed(() => {
      if (currentRouteIndex.value > 0) {
        return router.resolve({
          name: menu[currentRouteIndex.value - 1].routeName
        }).href
      }
      return null
    })

    const isSidebarVisible = ref(false)
    return {
      isSidebarVisible,
      toggleSidebar,
      showMobileFacets,
      faTimes,
      menu,
      nextUrl,
      previousUrl
    }
  },

  i18n: defineComponentTranslations({
    xml_specifications: {
      en: 'XML Specifications',
      el: 'Προδιαγραφές XML'
    },
    parts_and_small_classifieds: {
      en: 'Parts & Small classifieds',
      el: 'Ανταλλακτικά & Μικρές αγγελίες'
    },
    validator: {
      en: 'Xml validator',
      el: 'Επαληθευτής XML'
    }
  })
})
